import React from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';

const BoxlessSearch: React.FC<any> = () => (<></>);

export default connectSearchBox(BoxlessSearch);
